/**
 * Authorization claim prefixes for helpdesk features.
 * Combine with `-R`/`-W` suffixes (see `buildScreenPermissions`) and reference
 * from routes/menu so each claim code is written exactly once per feature.
 */

export const HDK_CLAIM = 'HDK';
export const HDK_CONFIG_CLAIM = 'HDK-CONFIG';
export const HDK_ISSUE_FILES_CLAIM = 'HDK-ISSUE-FILES';
export const HDK_ISSUE_MODULES_CLAIM = 'HDK-ISSUE-MODULES';
export const HDK_ISSUE_PRIORITIES_CLAIM = 'HDK-ISSUE-PRIORITIES';
export const HDK_ISSUE_SPRINTS_CLAIM = 'HDK-ISSUE-SPRINTS';
export const HDK_ISSUE_STATUSES_CLAIM = 'HDK-ISSUE-STATUSES';
export const HDK_ISSUE_STATUS_HISTORIES_CLAIM = 'HDK-ISSUE-STATUS-HISTORIES';
export const HDK_ISSUE_TYPES_CLAIM = 'HDK-ISSUE-TYPES';
export const HDK_ISSUE_WORKFLOW_ROLES_CLAIM = 'HDK-ISSUE-WORKFLOW-ROLES';
export const HDK_ISSUE_WORKFLOWS_CLAIM = 'HDK-ISSUE-WORKFLOWS';
export const HDK_ISSUES_CLAIM = 'HDK-ISSUES';

export const claimRead = (claimPrefix: string): string => `${claimPrefix}-R`;
export const claimWrite = (claimPrefix: string): string => `${claimPrefix}-W`;
